import React from 'react';
import moment from 'moment';
import * as utils from '../date_utils';
import CalendarMonth from './calendarmonth';
import CalendarHeader from './calendarheader';

export default class CalendarMonthRange extends React.Component {
    constructor(props) {
        super(props);

        this.state = { 
            displayedMonth: props.intervals.length === 0 ? null : moment(props.intervals[0].cmbDelayedIntervalId)
        }; 

        this.nextMonth = this.nextMonth.bind(this);
        this.prevMonth = this.prevMonth.bind(this);
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return this.props.value != nextProps.value || !utils.isSameMonth(this.state.displayedMonth, nextState.displayedMonth);
    // }

    renderDayNames(currentWeekStart) {
        return [0, 1, 2, 3, 4, 5, 6].map(offset => {
            const day = utils.addDays(utils.cloneDate(currentWeekStart), offset);
            const localeData = utils.getLocaleData(day);
            const weekDayName = this.props.useWeekdaysShort
                ? utils.getWeekdayShortInLocale(localeData, day)
                : utils.getWeekdayMinInLocale(localeData, day);
            return (
                <th key={offset} className="dayname">
                    {weekDayName}
                </th>
            );
        });
    }

    getDisplayedMonth() {
        return this.state.displayedMonth
            ? this.state.displayedMonth
            : (this.props.current
                ? this.props.current
                : moment());
    }

    prevMonth(e) {
        e.preventDefault();

        this.setState({displayedMonth: this.getDisplayedMonth().subtract(1, 'month')});
    }

    nextMonth(e) {
        e.preventDefault();

        this.setState({displayedMonth: this.getDisplayedMonth().add(1, 'month')});
    }

    render() {
        return (
            <React.Fragment>
                {this.props.isMobile && (<h1>Data</h1>)}
                <table className="monthpicker" key={'M'+0}>
                    <CalendarHeader onPrevMonth={this.prevMonth} onNextMonth={this.nextMonth} currentMonth={this.getDisplayedMonth().clone()} />
                    <CalendarMonth value={this.props.value} intervals={this.props.intervals} onMonthClick={this.props.onMonthClick} currentMonth={this.getDisplayedMonth().clone()} />
                </table>
            </React.Fragment>
        );
    }
}
